<div class="flex flex-row gap-2 h-full" (contextmenu)="tabRightClick($event)">
    <p-tabs #pTabs scrollable [value]="activeIndex" (valueChange)="onTabChange($event)" class="">
        <p-tablist>
            @for (tab of tabs$ | async; track tab?.tabId; let ind = $index) {
            <p-tab [value]="tab?.tabId ?? ind" #tabWrapper class="header-wrapper" [attr.data-tabId]="tab?.tabId"
                [attr.data-index]="ind" [attr.data-tablength]="(tabs$ | async)?.length"
                [ngClass]="{ 'unsaved-changes': (tabInfo$ | async)?.[tab?.tabId!]?.unsaved }"
                pTooltip="{{ (tabInfo$ | async)?.[tab?.tabId!]?.name || tab?.content?.name }}"
                (contextmenu)="contextMenuRightClick($event)" tooltipPosition="top">
                <!-- Tab icon -->
                @if (tab?.icon && tab?.tabType === tabTypeEnum.Home) {
                <i [class]="homeTabIcon"></i>
                } @else {
                <i [class]="tab?.icon"></i>
                }
                <!-- Tab name -->
                @if (tab?.tabType === tabTypeEnum.Home) {
                <span [ngClass]="{ 'tab-label home': homeTabLabel }">
                    {{ homeTabLabel }}
                </span>
                } @else {
                <span class="tab-label">
                    {{ (tabInfo$ | async)?.[tab?.tabId!]?.name || tab?.content?.name }}
                </span>
                }
                <!-- Closing button -->
                @if (tab?.closeable) {
                <span class="p-icon-wrapper" (click)="onTabClose(tab)">
                    <i class="pi pi-times-circle"></i>
                </span>
                }
            </p-tab>
            }
        </p-tablist>

        <p-tabpanels>
            @for (tab of tabs$ | async; track tab?.tabId; let ind = $index) {
            <p-tabpanel [value]="tab?.tabId ?? ind">
                @switch (tab?.tabType) {
                @case (tabTypeEnum.Home) {
                <router-outlet></router-outlet>
                @if (homeTabLabel === '') {
                <unified-ui-landing-page></unified-ui-landing-page>
                }
                }
                @case (tabTypeEnum.Report) {
                <!-- Enables dynamic component rendering without import in tab component -->
                <ng-container
                    *ngComponentOutlet="contentTypes[tab?.content?.type!]; inputs: { tabId: tab?.tabId, tab: tab }" />
                }
                @case (tabTypeEnum.Dashboard) {
                <!-- Enables dynamic component rendering without import in tab component -->
                <ng-container
                    *ngComponentOutlet="contentTypes[tab?.content?.type!]; inputs: { tabId: tab?.tabId, tab: tab }" />
                }
                }
            </p-tabpanel>
            }
        </p-tabpanels>
    </p-tabs>
</div>

@if (showContextMenu) {
<p-contextMenu #contextMenu [global]="true" appendTo="body" [model]="contextMenuItems">
    <ng-template pTemplate="item" let-item>
        <a class="flex align-items-center p-menuitem-link">
            {{ item.label }}
        </a>
    </ng-template>
</p-contextMenu>
}